import { createSlice, current } from "@reduxjs/toolkit";

const initialState = {
    solicitacoes: []
};

const participantesSlice = createSlice({
    name: "participantes",
    initialState,
    reducers: {
        adcionarParticipante: (state, action) => {
            let novoParticipante = action.payload[0];

            let solicitacaoJaAdicionada = 
                state.solicitacoes.findIndex(
                    (solic) => solic.CodigoSolicitacaoAcesso == novoParticipante.CodigoSolicitacaoAcesso
                );
            
            if ( solicitacaoJaAdicionada == -1 ) {
                let novaSolicitacao = {
                    CodigoSolicitacaoAcesso: 0,
                    Participantes: []
                };
        
                novaSolicitacao.CodigoSolicitacaoAcesso = novoParticipante.CodigoSolicitacaoAcesso;
                novaSolicitacao.Participantes = novoParticipante;
                
                state.solicitacoes.push(novaSolicitacao);
            } else {
                state.solicitacoes = state.solicitacoes.map((solic) => {
                    if (solic.CodigoSolicitacaoAcesso == novoParticipante.CodigoSolicitacaoAcesso) {
                        solic.Participantes.push(novoParticipante);
                    }
                })
            }        
            return state;
        },
        
        adicionarSolicitacao: (state, action) => {   
            let novaSolic = action.payload[0];
            
            let solicitacaoJaAdicionada = 
                state.solicitacoes.findIndex(
                    (solic) => solic?.CodigoSolicitacaoAcesso == novaSolic.CodigoSolicitacaoAcesso
                );
        
            let novoSolicitacao = {
                CodigoSolicitacaoAcesso: 0,
                Participantes: []
            }
        
            if (solicitacaoJaAdicionada == -1 ) {
                novoSolicitacao.CodigoSolicitacaoAcesso = novaSolic.CodigoSolicitacaoAcesso;
                
                if (typeof novaSolic == 'object') {
                    novoSolicitacao.Participantes = novaSolic;
                } else {
                    novaSolic.forEach(participante => {
                        novoSolicitacao.Participantes.push(participante);
                    });
                }
                
                state.solicitacoes.push(novoSolicitacao);
            } else {
                state.solicitacoes = state.solicitacoes.map((solict, index) => {
                    if (index == solicitacaoJaAdicionada) {
                        solict.Participantes = action.payload;
                    }
        
                    return solict;
                })
            }
        
            return state;
        },
        
        removerParticipante: (state, action) => {
            state.solicitacoes = state.solicitacoes.map((solicit) => {
                if (solicit.CodigoSolicitacaoAcesso == action.payload.CodigoSolicitacaoAcesso) {
                    solicit.Participantes = solicit.Participantes.filter((participante) => participante.Id != action.payload.Id)

                    console.log(current(solicit))
                }
        
                return solicit;
            });
                
            console.log(current(state))
            return state;
        }
        
    }
});

export const { adicionarSolicitacao, adcionarParticipante, removerParticipante } = participantesSlice.actions;
export default participantesSlice.reducer;